module.exports = __webpack_public_path__ + "img/app2.1bf4a4c3.png";